export default __webpack_public_path__ + "static/media/crown-first.d248d47a.svg";